import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class LightDiagnosticCypressAttribute extends CypressAttribute {
  static inputs = {
    JURISDICTION_SELECT: 'LightDiagnosticTestAttribute:inputs:JURISDICTION_SELECT'
  };

  static buttons: Record<string, string> = {
    BACK_TO_SELECTION: 'LightDiagnosticTestAttribute:buttons:BACK_TO_SELECTION',
    BACK_TO_SOLUTIONS: 'LightDiagnosticTestAttribute:buttons:BACK_TO_SOLUTIONS',
    COUPLE_TYPE_TOGGLE: 'LightDiagnosticTestAttribute:buttons:COUPLE_TYPE_TOGGLE'
  };

  static views: Record<string, string> = {
    BILLING_PLAN_CARD: 'LightDiagnosticTestAttribute:views:BILLING_PLAN_CARD',
    BILLING_PLAN_TITLE: 'LightDiagnosticTestAttribute:views:BILLING_PLAN_TITLE',
    CUSTOM_BILLING_PLAN_CARD: 'LightDiagnosticTestAttribute:views:CUSTOM_BILLING_PLAN_CARD'
  };
  static StarterBox: CypressAttribute = {
    inputs: {},
    buttons: {},
    views: {
      TITLE: 'LightDiagnosticTestAttribute:StarterBox:views:TITLE',
      SUBTITLE: 'LightDiagnosticTestAttribute:StarterBox:views:SUBTITLE',
      BUTTON_TEXT: 'LightDiagnosticTestAttribute:StarterBox:views:BUTTON_TEXT'
    }
  };
}
